import ActivityIcon from "../../../../../images/common/activity-blue.svg";
import UserIcon from "../../../../../images/common/user-blue.svg";
import OrdersIcon from "../../../../../images/common/cart-blue.svg";
import DonationIcon from "../../../../../images/common/heart-blue.svg";
import ItemIcon from "../../../../../images/sidebar/item-details-logo.svg";
import PaymentIcon from "../../../../../images/membership/dollar-blue.svg";
import InvoicesIcon from "../../../../../images/common/invoice-blue.svg";
// import QuotesIcon from '../../../../../images/common/quotes-blue.svg';
import SubscriptionIcon from "../../../../../images/membership/recurring.svg";
import CheckoutIcon from "../../../../../images/common/link-blue.svg";
import FundingIcon from "../../../../../images/common/funding-blue.svg";
import DisputesIcon from "../../../../../images/common/warning-blue.svg";
// import PromotionIcon from '../../../../../images/common/promotion-blue.svg';
// import TaxIcon from '../../../../../images/common/tax-tx-blue.svg';
import PaymentSettingsIcon from "../../../../../images/common/settings-blue.svg";
import ActiveActivityIcon from "../../../../../images/sidebar/activity-royal-blue.svg";
import ActiveUserIcon from "../../../../../images/sidebar/user-royal-blue.svg";
import ActiveOrdersIcon from "../../../../../images/sidebar/cart-royal-blue.svg";
import ActiveDonationIcon from "../../../../../images/sidebar/heart-royal-blue.svg";
import ActiveItemIcon from "../../../../../images/sidebar/item-details-blue.svg";
import ActivePaymentIcon from "../../../../../images/sidebar/dollar-royal-blue.svg";
import ActiveInvoicesIcon from "../../../../../images/sidebar/invoice-royal-blue.svg";
// import ActiveQuotesIcon from '../../../../../images/sidebar/quotes-royal-blue.svg';
import ActiveSubscriptionIcon from "../../../../../images/sidebar/recurring-royal-blue.svg";
import ActiveCheckoutIcon from "../../../../../images/sidebar/link-royal-blue.svg";
import ActiveFundingIcon from "../../../../../images/sidebar/funding-royal-blue.svg";
import ActiveDisputesIcon from "../../../../../images/sidebar/warning-royal-blue.svg";
// import ActivePromotionIcon from '../../../../../images/sidebar/promotion-royal-blue.svg';
// import ActiveTaxIcon from '../../../../../images/sidebar/tax-tx-royal-blue.svg';
import ActivePaymentSettingsIcon from "../../../../../images/sidebar/settings-royal-blue.svg";
import MerchantAccountIcon from "../../../../../images/sidebar/merchant-accounts-icon-blue.svg";
import ActiveMerchantAccountIcon from "../../../../../images/sidebar/merchant-accounts-icon-royal-blue.svg";
import { Location } from "react-router-dom";
import { ItemDropDownOptions } from "../enums";
import { removeSlashFromEnd } from "@mindmemobile/mm-shared-global";

type SideBarData = {
  title: ItemDropDownOptions;
  activeIcon: string;
  isActive: () => boolean;
  route?: string;
  icon: string;
  className?: string;
};
export class ItemSideBarModel {
  static checkActiveRoute(route: string, location: Location) {
    const fullRoute = "/app/items/" + route;
    switch (route) {
      case "merchant-accounts":
        return (
          location.pathname === removeSlashFromEnd("/app/merchant-accounts") ||
          location.pathname.includes("/app/merchant-accounts")
        );
      case "subscriptions":
        return (
          location.pathname.includes("/app/subscriptions") ||
          location.pathname.includes("/app/subscriptions/detail")
        );
      case "payments":
        return (
          location.pathname.includes("/app/payments") ||
          location.pathname.includes("/app/payments/detail")
        );
      case "invoices":
        return (
          location.pathname.includes("/app/invoices") ||
          location.pathname.includes("/app/invoices/detail")
        );
      case "contacts":
        return (
          location.pathname.includes("/app/contacts") ||
          location.pathname.includes("/app/contacts/detail")
        );
      case "orders":
        return (
          location.pathname.includes("/app/orders") ||
          location.pathname.includes("/app/orders/detail")
        );
      case "checkouts":
        return (
          location.pathname.includes("/app/checkouts") ||
          location.pathname.includes("/app/checkouts/detail")
        );
      case "purchase-link":
        return (
          location.pathname.includes("/app/purchase-link") ||
          location.pathname.includes("/app/purchase-link/detail")
        );
      case "payment-settings":
        return (
          location.pathname.includes("/app/payment-settings") ||
          location.pathname.includes("/app/payment-settings/detail")
        );
      case "funding":
        return (
          location.pathname.includes("/app/funding") ||
          location.pathname.includes("/app/funding/detail")
        );

      default:
        switch (fullRoute) {
          case "/app/items/":
            return (
              location.pathname === removeSlashFromEnd(fullRoute) ||
              location.pathname.includes("/app/items/detail") ||
              location.pathname.includes("/app/purchase-link/detail")
            );
          default:
            return location.pathname === removeSlashFromEnd("/app/" + route);
        }
    }
  }

  static getActiveRoute(location: Location): SideBarData | undefined {
    return ItemSideBarModel.getSideBarData(location).find((item) =>
      item.isActive()
    );
  }

  static getSideBarData(location: Location): SideBarData[] {
    return [
      {
        title: ItemDropDownOptions.Activity,
        route: "activity",
        activeIcon: ActiveActivityIcon,
        isActive: () => ItemSideBarModel.checkActiveRoute("activity", location),
        icon: ActivityIcon,
      },
      {
        title: ItemDropDownOptions.Contacts,
        activeIcon: ActiveUserIcon,
        isActive: () => ItemSideBarModel.checkActiveRoute("contacts", location),
        route: "contacts",
        icon: UserIcon,
      },
      {
        title: ItemDropDownOptions.Orders,
        activeIcon: ActiveOrdersIcon,
        isActive: () => ItemSideBarModel.checkActiveRoute("orders", location),
        route: "orders",
        icon: OrdersIcon,
      },
      {
        title: ItemDropDownOptions.Donations,
        activeIcon: ActiveDonationIcon,
        route: "donations",
        isActive: () =>
          ItemSideBarModel.checkActiveRoute("donations", location),
        icon: DonationIcon,
      },
      {
        title: ItemDropDownOptions.Items,
        activeIcon: ActiveItemIcon,
        route: "items",
        isActive: () => ItemSideBarModel.checkActiveRoute("", location),
        icon: ItemIcon,
      },
      {
        title: ItemDropDownOptions.Payments,
        activeIcon: ActivePaymentIcon,
        isActive: () => ItemSideBarModel.checkActiveRoute("payments", location),
        route: "payments",
        icon: PaymentIcon,
      },
      {
        title: ItemDropDownOptions.Invoices,
        activeIcon: ActiveInvoicesIcon,
        isActive: () => ItemSideBarModel.checkActiveRoute("invoices", location),
        route: "invoices",
        icon: InvoicesIcon,
      },
      // {
      //     title: ItemDropDownOptions.Quotes,
      //     activeIcon: ActiveQuotesIcon,
      //     className: 'disabled',
      //     isActive: () => ItemSideBarModel.checkActiveRoute('quotes', location),
      //     route: 'quotes',
      //     icon: QuotesIcon,
      // },
      {
        title: ItemDropDownOptions.Subscriptions,
        activeIcon: ActiveSubscriptionIcon,
        isActive: () =>
          ItemSideBarModel.checkActiveRoute("subscriptions", location),
        route: "subscriptions",
        icon: SubscriptionIcon,
      },
      {
        title: ItemDropDownOptions.Checkout,
        activeIcon: ActiveCheckoutIcon,
        isActive: () =>
          ItemSideBarModel.checkActiveRoute("checkouts", location),
        route: "checkouts",
        icon: CheckoutIcon,
      },
      {
        title: ItemDropDownOptions.Funding,
        activeIcon: ActiveFundingIcon,
        isActive: () => ItemSideBarModel.checkActiveRoute("funding", location),
        route: "funding",
        icon: FundingIcon,
      },
      {
        title: ItemDropDownOptions.Disputes,
        activeIcon: ActiveDisputesIcon,
        isActive: () => ItemSideBarModel.checkActiveRoute("disputes", location),
        route: "disputes",
        icon: DisputesIcon,
      },
      // {
      //     title: ItemDropDownOptions.Promotions,
      //     activeIcon: ActivePromotionIcon,
      //     className: 'disabled',
      //     isActive: () => ItemSideBarModel.checkActiveRoute('promotions', location),
      //     route: 'promotions',
      //     icon: PromotionIcon,
      // },
      // {
      //     title: ItemDropDownOptions.Tax,
      //     activeIcon: ActiveTaxIcon,
      //     className: 'disabled',
      //     isActive: () => ItemSideBarModel.checkActiveRoute('tax', location),
      //     route: 'tax',
      //     icon: TaxIcon,
      // },
      {
        title: ItemDropDownOptions.PaymentSettings,
        activeIcon: ActivePaymentSettingsIcon,
        isActive: () =>
          ItemSideBarModel.checkActiveRoute("payment-settings", location),
        route: "payment-settings",
        icon: PaymentSettingsIcon,
      },
      {
        title: ItemDropDownOptions.MerchantAccounts,
        activeIcon: ActiveMerchantAccountIcon,
        isActive: () =>
          ItemSideBarModel.checkActiveRoute("merchant-accounts", location),
        route: "merchant-accounts",
        icon: MerchantAccountIcon,
      },
    ];
  }
}
